import React, { Component } from "react";
import { css } from "aphrodite";
import { styles } from "./ForgotPasswordStyles";
import { Field, reduxForm } from "redux-form";

import { connect } from "react-redux";
import { passwordActions, userActions } from "../_actions";
import Header from "../components/Header";
import queryString from "query-string";
import ErrorMessage from "../components/ErrorMessage";
import moment from "moment";
import { Redirect } from "react-router-dom";

const validate = values => {
  const errors = {};
  if (!values.new_password) {
    errors.new_password = "New password is required";
  }
  if (
    !/(?=.*[~!@#$%^&*_\-+=`|\\(){}[\]:;\“\"\’\'<>,.?])/.test(
      values.new_password
    )
  ) {
    errors.new_password = "Your password must contain a special character.";
  }
  if (/^\d+$/.test(values.new_password)) {
    errors.new_password =
      "This password is entirely numeric. Please add at least 1 character.";
  }
  if (values.new_password && values.new_password.length < 8) {
    errors.new_password =
      "This password is too short. It must contain at least 8 characters.";
  }
  if (!/[a-z]/.test(values.new_password)) {
    errors.new_password = "Your password must contain a lowercase letter.";
  }
  if (!/[A-Z]/.test(values.new_password)) {
    errors.new_password = "Your password must contain an uppercase letter.";
  }
  if (!values.verify_password) {
    errors.verify_password = "Please confirm your password";
  }
  if (values.new_password && values.new_password !== values.verify_password) {
    errors.new_password = "Your new passwords do not match";
  }
  return errors;
};

const renderField = props => {
  const {
    input,
    label,
    type,
    minLength,
    meta: { touched, error, warning }
  } = props;

  const inputStyles = css([
    styles.input,
    touched && error && styles.inputError
  ]);
  return (
    <div>
      <input
        {...input}
        placeholder={label}
        type={type}
        className={inputStyles}
        minLength={minLength}
      />
      {touched &&
        ((error && <span className={css(styles.error)}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  );
};
let NewPasswordLoggedOutForm = props => {
  const {
    handleSubmit,
    pristine,
    submitting,
    onSubmit,
    submitSucceeeded,
    submitFailed
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <p className={css(styles.paragraph)}>
          Please enter your new password to log in.
        </p>
        <Field
          name="new_password"
          component={renderField}
          type="password"
          label="New password"
        />
        <Field
          name="verify_password"
          component={renderField}
          type="password"
          label="Confirm password"
        />
      </div>

      <div>
        <button
          type="submit"
          disabled={pristine || submitting}
          className={css(styles.buttonWhite)}
        >
          Save New Password and Log In
        </button>
      </div>
    </form>
  );
};

class NewPasswordLoggedOut extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: ""
    };
  }

  submit = values => {
    const queryValues = queryString.parse(this.props.location.search);
    this.setState({
      password: values.new_password
    });
    this.props.dispatch(
      passwordActions.setPasswordWithToken(
        queryValues.token,
        values.new_password
      )
    );
  };

  render() {
    let successCode = null;
    let successDetail = null;
    try {
      successCode = this.props.password.detail.code;
      successDetail = this.props.password.detail.message;
    } catch (err) {}

    const queryValues = queryString.parse(this.props.location.search);
    let tokenExpired = false;
    if (successCode === 1) {
      tokenExpired = true;
    } else if (moment().isAfter(moment.unix(queryValues.exp_date))) {
      tokenExpired = true;
    }

    // successCode === 0 && this.props.history.push("/");
    if (successCode === 0) {
      // return <Redirect to="/" />;
      this.props.dispatch(
        userActions.login(
          this.props.password.detail.username,
          this.state.password
        )
      );
    }
    return (
      <div>
        <Header
          title={"Password Recovery"}
          loggedOut={true}
          backTitle={"Login"}
          backHref={"/"}
          hideAccount={true}
        />
        <div className={css(styles.background)}>
          <div className={css(styles.wrapper)}>
            <NewPasswordLoggedOutForm onSubmit={this.submit} />
            {successCode === 2 &&
              successDetail.map(item => {
                return <ErrorMessage message={item} />;
              })}
            {tokenExpired && (
              <ErrorMessage
                message={[
                  "Token expired, please ",
                  <a className={css(styles.inlineLink)} href="/forgot-password">
                    reset your password again
                  </a>,
                  "."
                ]}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    password: state.password
  };
}

NewPasswordLoggedOutForm = reduxForm({
  form: "new-password-logged-out",
  validate
})(NewPasswordLoggedOutForm);

export default connect(mapStateToProps)(NewPasswordLoggedOut);
